import React from "react";
import { problemList } from "../../data/megapack";
import { E } from "../Emoji";
export function ProblemSection() {
  return <section aria-labelledby="problema" className="bg-night" data-id="element-233" data-mp="n8epx115r6qz">
      <div className="mx-auto max-w-2xl px-5 py-14 text-center" data-id="element-234" data-mp="8lbpalhjghzf">
        <h2 id="problema" className="text-3xl font-black leading-tight text-white md:text-4xl" data-id="element-235" data-mp="8izagh72unql">
          ¿Cuántas veces más vas a quedarte sin saber qué hacer?
        </h2>
        <p className="mt-4 font-semibold text-white/80" data-id="element-236" data-mp="3vnydpkj27wyn">
          No desagota. No centrifuga. Pierde agua. Hace ruido. Buscás en Internet y cada video dice algo distinto.
        </p>
        <p className="mt-4 font-black text-bright" data-id="element-237" data-mp="3lsn7xrpmq031">No es falta de capacidad. Es falta de un método.</p>

        <ul className="mt-8 space-y-3 text-left" data-id="element-238" data-mp="3qr7yt0izr7et">
          {problemList.map(p => <li key={p} className="flex items-start gap-3 rounded-2xl border border-red/25 bg-blood p-4 font-bold text-white" data-id="element-239" data-mp="1k10ezkm6fv3x">
              <span className="text-xl leading-none" data-id="element-240" data-mp="1oya9heofawym"><E data-id="element-241" data-mp="1nnky28cvad9n">❌</E></span>
              <span data-id="element-242" data-mp="1nmt22wfcydiu">{p}</span>
            </li>)}
        </ul>

        <p className="mt-10 text-2xl font-black italic leading-tight text-bright" data-id="element-243" data-mp="1iozv4168dfhi">
          ¿Y si esta fuera la última vez que te pasa?
        </p>

        <p className="mx-auto mt-8 inline-block rounded-full border border-line px-4 py-2 text-xs font-black uppercase tracking-wide text-sky" data-id="element-244" data-mp="1wfmyi6mxrtjx">
          <E data-id="element-245" data-mp="14op48y4x80wc">🏆 Senvoria Digital™ Megapack Lavarropas</E>
        </p>
        <p className="mt-6 text-3xl font-black leading-tight text-white md:text-4xl" data-id="element-246" data-mp="14r2xr2jyd51s">
          6 Tomos + 5 Bonos — Fallas y soluciones
          <span className="block text-bright" data-id="element-247" data-mp="1dpeuznfbr137">Todo organizado por síntomas.</span>
        </p>
      </div>
    </section>;
}